if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    static instanceCount = 0;

    constructor() {
      super();
      this.sectionId = this.dataset.section + '-' + ProductMain.instanceCount++; // for Unique product component IDs
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.fillProductData();
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options_with_values.filter(x=>(requiredOptionsSettingUnique.indexOf(x.name)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && x.values.length>1).map(x=>x.name);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));

      
}

    fillProductData() {
      const isMerge = this.productData.is_product_merge;
      
        this.productData.options_with_values.forEach(option=>{
          option.values = option.values.map(x=>{
            return {"value": x, "available": true }; //availability calculated by filtered variants in getOptionValues function
          });
        });if (this.productData.is_product_main) {
        let altPerProduct = {}
        this.productData.media = Array.from(this.querySelectorAll('product-gallery [data-media-id]')).map((media)=>{
          let alt;
          if (!isMerge) {}
          return {
            "alt": alt,
            "id": media.getAttribute('data-media-id')
          };
        });
      }

    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options_with_values.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      // Lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}}
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
        
      }


      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            tag = tag.replace('<product-swatch', '<product-swatch data-trim-options-limit="0"');
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    // Added to match colors on product cards loaded through ajax, probably not needed for main product sections
    copySchemeFrom(el) {
      var lookForClasses = ['scheme','color-scheme-1','color-scheme-2','color-scheme-3','color-scheme-c2fe20a5-e41a-478e-bb82-f8993ea1780e','color-scheme-0bff3023-295f-48f3-86d3-9c3dcf837936','color-scheme-homepage-title-navy', 'same-scheme-true', 'same-scheme-false'];
      lookForClasses.forEach(name=>{
        if (el.classList.contains(name)) {
          this.classList.add(name);
        } else {
          this.classList.remove(name);
        }
      })
      
    }

    openOptions(e) {
      e.preventDefault()
      const currentVariant = this.getCurrentVariant();
      if (currentVariant && currentVariant.available) {
        const inputs = this.querySelectorAll(
          'input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select'
        );
        if (inputs.length==0) {
          this.querySelector('.btn.add').click();
          return;
        }
      }
      
      if (this.querySelector('.atc-options-wrapper').classList.contains('open')) {
        return;
      }
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_media : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      // Update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options_with_values.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      this.soldOutMessage = this.querySelector('.sold-out-message');
      this.isSoldOut = false;
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.isSoldOut = false;
          this.updateSoldOutMessage();
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add').style.display = '';
          this.isSoldOut = false;
          this.updateSoldOutMessage();
          if (requiredBtn) requiredBtn.style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          this.isSoldOut = true;
          this.updateSoldOutMessage();
          if (requiredBtn) requiredBtn.style.display = 'none';
      	}
      });

      this.watchKlaviyoBackInStock();
    }

    updateSoldOutMessage() {
      if (!this.soldOutMessage) return;
      this.soldOutMessage.style.display = this.isSoldOut && !this.klaviyoBackInStockVisible() ? '' : 'none';
    }

    klaviyoBackInStockVisible() {
      var container = this.mainElement.querySelector('#klaviyo-bis-button-container');
      if (!container) return false;

      var style = window.getComputedStyle(container);
      var rect = container.getBoundingClientRect();
      return style.display != 'none' && style.visibility != 'hidden' && rect.width > 0 && rect.height > 0;
    }

    watchKlaviyoBackInStock() {
      if (!this.soldOutMessage) return;

      this.klaviyoBackInStockObserver = new MutationObserver(()=>{
        this.updateSoldOutMessage();
      });
      this.klaviyoBackInStockObserver.observe(this.mainElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
      this.updateSoldOutMessage();
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options_with_values.findIndex(x=>x.name==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.videoAutoplay = this.dataset.videoAutoplay;
      this.autoplayOptionsElement = this.videoAutoplay ? this.querySelector('.autoplay-options') : null;
      this.autoplayCheck = this.autoplayOptionsElement ? this.autoplayOptionsElement.querySelector('input') : null;
      this.itemsPerViewMobile = this.dataset.itemsPerViewMobile ? this.dataset.itemsPerViewMobile/1 : 1;
      if (this.autoplayCheck) {
        this.autoplayCheck.addEventListener('change', (e)=>{
          Cookies.set('autoplay', e.target.checked ? 'enabled' : 'disabled');
        });
        this.autoplayCheck.checked = Cookies.get('autoplay') !== 'disabled';
      }

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.mobileStyle=='carousel') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            slidesPerView: this.itemsPerViewMobile
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'em)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          pageInfo: this.querySelector('.keen-slider-page'),
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            let canPlay = true;
            if (this.autoplayOptionsElement) {
              this.autoplayOptionsElement.classList.remove('visible');
            }
            if (this.videoAutoplay) {
              const media = keen.currentSlide().querySelector('.media');
              if (this.autoplayOptionsElement && media) { // && media is to only show the checkbox on video slides.
                this.autoplayOptionsElement.classList.add('visible');
                //TODO eval  checkbox
                this.autoplayCheck.checked = canPlay = Cookies.get('autoplay')!='disabled';
              }
              if (media && canPlay) {
                $s.playMedia(media);
              }
            }
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle.indexOf('thumbnails')>-1) || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    getVerticalSlidesPerView() {
      const sliderHeight = this.itemsWrapper.getBoundingClientRect().height;
      const thumbnailWidth = this.getBoundingClientRect().width;
      const galleryRect = this.mainGallery.getBoundingClientRect();
      const gapRem = parseFloat(getComputedStyle(this).getPropertyValue('--thumbs-gap')) || 0;
      const gap = $s.calcRemToPx(gapRem);
      if(!sliderHeight || !thumbnailWidth || !galleryRect.width || !galleryRect.height) {
        const visibleThumbnails = Array.from(this.itemsWrapper.querySelectorAll('.thumb-wrap')).filter((thumbnail) => $s.isVisible(thumbnail));
        return visibleThumbnails.length || 1;
      }
      const thumbnailHeight = thumbnailWidth * galleryRect.height / galleryRect.width;
      return sliderHeight / (thumbnailHeight + gap);
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            spacing: 0,
            slidesPerView: () => this.getVerticalSlidesPerView()
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        		this.finalPriceElement.innerHTML = $s.formatMoney(data.price * quantity).replace('.00','');

            if(data.compare_at_price > data.price) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(data.compare_at_price * quantity).replace('.00','');
        		  this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(data.price * quantity).replace('.00','');
            } else {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
        	} else {
        		this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
        	}
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })
      this.combinedListingOptions = [];
      

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
        
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}));
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var optionIndex = this.swatchImg.dataset.option/1 -1;
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v => {
              if (v.options[optionIndex] !== radio.value) return false;
              // All other options must match the current variant
              for (let i = 0; i < v.options.length; i++) {
                if (i === optionIndex) continue;
                if (v.options[i] !== variant.options[i]) return false;
              }
              return true;
            });
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(
                v => v.options[optionIndex] == radio.value
              );
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_media) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_media.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options_with_values.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = this.previousVariant ? newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]) : [];
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    
    
    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content scheme" style="width: ${infoLink.dataset.width}rem">
                <img alt="" src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    // Get values with availability that depends on previous options
    getOptionValues(currentVariant) {
      var options = [];
      var variants = this.mainElement.productData.variants;
      options = structuredClone(this.mainElement.productData.options_with_values.map(x=>x.values));
      options.forEach((values, index) => {
        
        // Filter variants that match previous selections
        let filteredVariants = variants;
        for (let prev = 0; prev < index; prev++) {
          filteredVariants = filteredVariants.filter(
            v => v.options[prev] === currentVariant.options[prev]
          );
        }
        let retValues = [];
        values.forEach((valueObj) => {
          const matchingVariants = filteredVariants.filter(
            v => v.options[index] === valueObj.value
          );
          if (matchingVariants.length > 0) {
            valueObj.available = matchingVariants.some(v => v.available);
            retValues.push(valueObj);
          }
        })
        options[index] = retValues;
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.trimOptionsLimit = this.dataset.trimOptionsLimit ? parseInt(this.dataset.trimOptionsLimit) : null;
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
  		var html = `
        <div class="option-name small-label">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${this.label}: </span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      const isInteractive = !this.closest('[aria-hidden="true"]');
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch2-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        
        if (!this.trimOptionsLimit || index < this.trimOptionsLimit) {
          html += `
            <div class="swatch" data-available="${option.available}">
              <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" ${!isInteractive ? 'tabindex="-1"':''} />
              <label for="${id}">
                <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
                  <span>${option.value}${soldOut}</span>
                </div>
              </label>
            </div>
          `;
        } else if (index === this.trimOptionsLimit) {
          html += `<div class="swatch swatch-remaining">+${options.length - this.trimOptionsLimit} ${lngg.product_card__swatches_more}</div>`;
        }
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      const isInteractive = !this.closest('[aria-hidden="true"]');
      var html = `
        <label class="option-name small-label" for="${optionId}">
        ${this.infoIcon}${this.label}: 
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}" ${!isInteractive ? 'tabindex="-1"':''}></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



